import { CSSProperties } from 'react';
import * as React from 'react';

export interface ITextFormat {
  children: React.ReactNode;
  classes?: string;
  style?: CSSProperties;
}

export function BuildPlainSpan({ children, classes, style }: ITextFormat) {
  return (
    <span className={classes} style={style}>
      {children}
    </span>
  );
}

export function BuildPlainH4({ children, classes, style }: ITextFormat) {
  return (
    <h4 className={classes} style={style}>
      {children}
    </h4>
  );
}

export function BuildPlainSmallText({ children, classes, style }: ITextFormat) {
  return (
    <small className={classes} style={style}>
      {children}
    </small>
  );
}

export function BuildPlainSmallParagraph({ children, classes, style }: ITextFormat) {
  return (
    <p className={classes} style={style}>
      {children}
    </p>
  );
}
